import { NAV_ITEM_ID } from './constants';
import * as items from './items';
const itemsMap = {
  [NAV_ITEM_ID.about]: items.aboutMenuItem,
  [NAV_ITEM_ID.access]: items.customerAccessMenuItem,
  [NAV_ITEM_ID.accessibility]: items.accessibilityMenuItem,
  [NAV_ITEM_ID.myAccount]: items.myAccountMenuItems,
  [NAV_ITEM_ID.billing]: items.billingMenuItem,
  [NAV_ITEM_ID.accountSettings]: items.accountSettingsMenuItem,
  [NAV_ITEM_ID.partnerAccountSettings]: items.partnerAccountSettingsMenuItem,
  [NAV_ITEM_ID.contact]: items.contactMenuItem,
  [NAV_ITEM_ID.datasets]: items.datasetsMenuItem,
  [NAV_ITEM_ID.deploymentKeys]: items.deploymentKeysMenuItem,
  [NAV_ITEM_ID.documentation]: items.documentationMenuItem,
  [NAV_ITEM_ID.partnerDocumentation]: items.partnerDocumentationMenuItem,
  [NAV_ITEM_ID.myOffers]: items.myOffersMenuItem,
  [NAV_ITEM_ID.feedback]: items.feedbackMenuItem,
  [NAV_ITEM_ID.logout]: items.logoutMenuItem,
  [NAV_ITEM_ID.legal]: items.partnerLegalLinkItem,
  [NAV_ITEM_ID.internationalSelling]: items.internationalSellingLinkItem,
  [NAV_ITEM_ID.marketplace]: items.marketplaceMenuItem,
  [NAV_ITEM_ID.myDashboard]: items.myDashboardMenuItem,
  [NAV_ITEM_ID.usage]: items.usageMenuItem,
  [NAV_ITEM_ID.myCompany]: items.myCompanyLinkItem,
  [NAV_ITEM_ID.myClusters]: items.myClustersMenuItem,
  [NAV_ITEM_ID.myRequests]: items.myRequestsMenuItem,
  [NAV_ITEM_ID.mySoftware]: items.mySoftwareMenuItem,
  [NAV_ITEM_ID.myTeam]: items.accessMenuItem,
  [NAV_ITEM_ID.serviceIds]: items.serviceIdItem,
  [NAV_ITEM_ID.myTeamPartner]: items.partnerMyTeamItem,
  [NAV_ITEM_ID.partnerServiceIds]: items.partnerServiceIdItem,
  [NAV_ITEM_ID.partnerAccess]: items.partnerAccessMenuItem,
  [NAV_ITEM_ID.myUpdates]: items.myUpdatesMenuItem,
  [NAV_ITEM_ID.paymentSettings]: items.paymentSettingsLinkItem,
  [NAV_ITEM_ID.privacy]: items.privacyPolicyMenuItem,
  [NAV_ITEM_ID.manageOffers]: items.privateOffersMenuItem,
  [NAV_ITEM_ID.profile]: items.profileMenuItem,
  [NAV_ITEM_ID.signIn]: items.signInMenuItem,
  [NAV_ITEM_ID.support]: items.supportMenuItem,
  [NAV_ITEM_ID.systemStatus]: items.systemStatusItem,
  [NAV_ITEM_ID.terms]: items.termsOfUseMenuItem,
  [NAV_ITEM_ID.rhmTerms]: items.rhmTermsOfServiceMenuItem,
  [NAV_ITEM_ID.workspace]: items.workspaceMenuItem,
  [NAV_ITEM_ID.pendingCharges]: items.pendingChargesMenuItem,
  [NAV_ITEM_ID.paymentMethod]: items.paymentMethodMenuItem,
  [NAV_ITEM_ID.invoices]: items.invoicesMenuItem,
  [NAV_ITEM_ID.performance]: items.performanceMenuItem,
  [NAV_ITEM_ID.privateOffers]: items.privateOffersMenuItem,
  [NAV_ITEM_ID.partnerProducts]: items.partnerProductsMenuItem,
  [NAV_ITEM_ID.marketplaceSelectCustomization]: items.customizationEditorMenuItem,
  [NAV_ITEM_ID.marketplaceSelectTagManagement]: items.tagManagementMenuItem,
  [NAV_ITEM_ID.marketplaceSelect]: items.marketplaceSelectMenuItem,
  [NAV_ITEM_ID.credits]: items.creditsMenuItem
};
export default itemsMap;